import React, { useState, useEffect, useContext, useCallback } from "react";
import Box from "@mui/material/Box";
import HeaderAppBar from "../../components/Appbar";
import { VariablesContext } from "../../contexts/variablesContext";
import FlowTest from "../../components/flowTest";
import { v4 as uuidv4 } from "uuid";
import { UsedVariablesContext } from "../../contexts/usedVariablesContext";
import api from "../../utils/api";
import "./styles.css";
import { QueuesContext } from "../../contexts/queuesContext";
import Swal from "sweetalert2";
import { IndexContext } from "../../contexts/indexContext";
const LandingPage = () => {
  const attributionDiv = document.querySelector(".react-flow__attribution");
  if (attributionDiv) {
    attributionDiv.style.display = "none";
  }

  const id = uuidv4();

  const decryptKey = process.env.REACT_APP_CRYPTO_PASSWORD;
  const [decryptedData, setDecryptedData] = useState(null);
  const [decryptReady, setDecryptReady] = useState(false);
  var CryptoJS = require("crypto-js");

  const decryptPayloadFromUrl = async () => {
    const decryptKeys = [decryptKey, "senhasupersecreta"].filter(Boolean);
    const pathname = (window.location.pathname || "").replace(/^\/+/, "").trim();
    const lastSegment = pathname.split("/").filter(Boolean).pop() || "";
    const candidates = [...new Set([pathname, decodeURIComponent(pathname), lastSegment, decodeURIComponent(lastSegment)]
      .map((item) => (item || "").trim())
      .filter((item) => Boolean(item) && item.length >= 32)
      .sort((a, b) => b.length - a.length))];

    const parseAndValidate = (text, sourceLabel) => {
      let parsed;
      try {
        parsed = JSON.parse(text);
      } catch {
        throw new Error(`Payload invalido (${sourceLabel}).`);
      }
      if (!parsed || typeof parsed !== "object") throw new Error(`Payload invalido (${sourceLabel}).`);
      if (typeof parsed.userId !== "string" || !parsed.userId.trim()) throw new Error(`Payload invalido (${sourceLabel}).`);
      if (typeof parsed.botId !== "string" || !parsed.botId.trim()) throw new Error(`Payload invalido (${sourceLabel}).`);
      if (!Array.isArray(parsed.serviceQueues)) throw new Error(`Payload invalido (${sourceLabel}).`);
      return parsed;
    };

    const normalizeBase64Cipher = (ciphertext) => {
      const decodedCiphertext = decodeURIComponent(ciphertext || "");
      const withoutSpaces = decodedCiphertext.replace(/ /g, "+");
      const urlSafeToBase64 = withoutSpaces.replace(/-/g, "+").replace(/_/g, "/");
      const missingPadding = urlSafeToBase64.length % 4;
      const padding = missingPadding === 0 ? "" : "=".repeat(4 - missingPadding);
      return `${urlSafeToBase64}${padding}`;
    };

    const decryptGCM = async (ciphertext, password) => {
      const normalizedCiphertext = normalizeBase64Cipher(ciphertext);
      const combined = new Uint8Array(
        atob(normalizedCiphertext).split("").map((char) => char.charCodeAt(0))
      );
      const salt = combined.slice(0, 16);
      const iv = combined.slice(16, 28);
      const encrypted = combined.slice(28);
      const keyMaterial = await crypto.subtle.importKey(
        "raw",
        new TextEncoder().encode(password),
        { name: "PBKDF2" },
        false,
        ["deriveBits", "deriveKey"]
      );
      const key = await crypto.subtle.deriveKey(
        { name: "PBKDF2", salt, iterations: 100000, hash: "SHA-256" },
        keyMaterial,
        { name: "AES-GCM", length: 256 },
        false,
        ["decrypt"]
      );
      const decrypted = await crypto.subtle.decrypt({ name: "AES-GCM", iv }, key, encrypted);
      return new TextDecoder("utf-8").decode(decrypted);
    };

    let lastError = null;
    for (const ciphertext of candidates) {
      for (const keyPassword of decryptKeys) {
        try {
          const legacyText = CryptoJS.AES.decrypt(ciphertext, keyPassword).toString(CryptoJS.enc.Utf8);
          if (legacyText) {
            const parsedLegacy = parseAndValidate(legacyText, "legacy-cryptojs");
            console.log("[FLOW_DECRYPT_OK]", {
              source: "legacy-cryptojs",
              botId: parsedLegacy.botId,
              userId: parsedLegacy.userId,
              decryptedPayload: parsedLegacy,
            });
            return parsedLegacy;
          }
        } catch (errorLegacy) {
          lastError = errorLegacy;
        }

        try {
          const gcmText = await decryptGCM(ciphertext, keyPassword);
          const parsedCryptoUtils = parseAndValidate(gcmText, "cryptoUtils");
          console.log("[FLOW_DECRYPT_OK]", {
            source: "cryptoUtils",
            botId: parsedCryptoUtils.botId,
            userId: parsedCryptoUtils.userId,
            decryptedPayload: parsedCryptoUtils,
          });
          return parsedCryptoUtils;
        } catch (errorCryptoUtils) {
          lastError = errorCryptoUtils;
          console.error("Erro ao descriptografar payload da URL.", {
            ciphertextPreview: (ciphertext || "").slice(0, 32),
            keyPreview: `${String(keyPassword).slice(0, 3)}***`,
            errorCryptoUtils,
          });
        }
      }
    }

    throw lastError || new Error("Nao foi possivel descriptografar o payload.");
  };

  const botId = decryptedData?.botId;

  useEffect(() => {
    let mounted = true;

    const runDecrypt = async () => {
      try {
        const result = await decryptPayloadFromUrl();
        if (mounted) {
          setDecryptedData(result);
          setDecryptReady(true);
        }
      } catch (error) {
        console.error("Erro ao preparar dados de entrada do flow.", error);
        if (mounted) {
          setDecryptReady(true);
        }
      }
    };

    runDecrypt();
    return () => {
      mounted = false;
    };
  }, []);

  const [loadedFlowFlag, setLoadedFlowFlag] = useState(false);
  // State to manage the current flow index
  // const [index, setIndex] = useState(0);
  const { headerIndex, setHeaderIndex } = useContext(IndexContext);
  // Contexts for managing variables and used variables
  const { variables, setVariables, setGlobalUser, globalUser } =
    useContext(VariablesContext);
  const { usedVariables, setUsedVariables } = useContext(UsedVariablesContext);
  const { setQueues } = useContext(QueuesContext);

  useEffect(() => {
    if (!decryptedData) return;
    setQueues(decryptedData.serviceQueues);
    setGlobalUser(decryptedData.userId);
  }, [decryptedData]);

  const [flows, setFlows] = useState([]);
  useEffect(() => {
    if (!botId) return;
    const getFlows = async () => {
      try {
        await api
          .get(`/getValue/${botId}`)
          .then((res) => {
            if (res.data.parsed !== null) {
              setUsedVariables(res.data.parsed.usedVariables);
              setFlows(res.data.parsed.flows);
              const storedVariables = res.data.parsed.variables;

              const globalUserAsObject = {
                label: "IDUsuarioLogado",
                type: "texto",
                data: { label: `${decryptedData.userId}` },
              };

              const firstMessageObject = {
                label: "PrimeiraMensagem",
                type: "texto",
                data: { label: "PrimeiraMensagem" },
              };

              const globalUserExists = storedVariables.find(
                (variable) => variable.label === "IDUsuarioLogado"
              );

              const firstMessageExists = storedVariables.find(
                (variable) => variable.label === "PrimeiraMensagem"
              );

              if (!globalUserExists && !firstMessageExists) {
                setVariables([
                  ...storedVariables,
                  globalUserAsObject,
                  firstMessageObject,
                ]);
              } else {
                setVariables(res.data.parsed.variables);
              }
            } else {
              const globalUserAsObject = {
                label: "IDUsuarioLogado",
                type: "texto",
                data: { label: `${decryptedData.userId}` },
              };
              const firstMessageObject = {
                label: "PrimeiraMensagem",
                type: "texto",
                data: { label: "PrimeiraMensagem" },
              };

              const savedFlows = localStorage.getItem("flows");
              if (savedFlows.length > 2) {
                setFlows(JSON.parse(savedFlows));
                const savedVariables = localStorage.getItem("variables");
                setVariables(JSON.parse(savedVariables));
                const savedUsedVariables =
                  localStorage.getItem("usedVariables");
                setUsedVariables(JSON.parse(savedUsedVariables));
              } else {
                setFlows([
                  {
                    id: uuidv4(),
                    name: `Flow 1`,
                    label: `Flow 1`,
                    nodes: [
                      {
                        id: id,
                        type: "start",
                        position: { x: 0, y: 0 },
                        data: {
                          label: `start`,
                          id: id,
                        },
                      },
                    ],
                    edges: [],
                  },
                ]);

                setVariables([globalUserAsObject, firstMessageObject]);

                setUsedVariables([]);
              }
            }
          })
          .finally(() => {
            setLoadedFlowFlag(true);
          });
      } catch (error) {
        console.error("Error fetching flows:", error);
        // Handle error or set default value if needed
      }
    };

    getFlows();
  }, [botId]);

  // State to manage data to save, combining flows, variables, and used variables
  const [dataToSave, setDataToSave] = useState({
    flows: flows,
    variables: variables,
    usedVariables: usedVariables,
  });

  // Effect to save data to the server and local storage whenever flows, variables, or used variables change
  useEffect(() => {
    const newData = {
      flows: flows,
      variables: variables,
      usedVariables: usedVariables,
    };

    setDataToSave(newData);
    // saveFlows();

    localStorage.setItem("flows", JSON.stringify(flows));
    localStorage.setItem("variables", JSON.stringify(variables));
    localStorage.setItem("usedVariables", JSON.stringify(usedVariables));
  }, [flows, variables, usedVariables]);

  // Add new flow to the list of flows
  const addNewFlow = () => {
    const newId = uuidv4();

    setFlows([
      ...flows,
      {
        id: uuidv4(),
        name: `Flow ${flows.length + 1}`,
        label: `Flow ${flows.length + 1}`,
        nodes: [
          {
            id: newId,
            type: "start",
            position: { x: 0, y: 0 },
            data: {
              label: `start`,
              id: newId,
            },
          },
        ],
        edges: [],
      },
    ]);
  };

  // Calculate container height based on window height
  const [containerHeight, setContainerHeight] = useState(
    window.innerHeight - 90
  );

  // Adjust container height on window resize
  useEffect(() => {
    const handleResize = () => {
      setContainerHeight(window.innerHeight - 90);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [containerHeight]);

  const findNodesBeingTarget = () => {
    const nodesBeingTarget = [];
    flows[headerIndex].nodes.forEach((node) => {
      const nodeBeingTarget = flows[headerIndex].edges.find(
        (edge) => edge.target === node.id
      );
      if (nodeBeingTarget) {
        nodesBeingTarget.push(node);
      }
    });
    return nodesBeingTarget;
  };

  const findNodesBeingTargetButNotSource = (nodesBeingTarget) => {
    const nodesBeingTargetButNotSource = [];
    nodesBeingTarget.forEach((node) => {
      if (node.type === "api" || node.type === "date" || node.type === "day") {
        // check if theres more than one connection where the node is the source
        const nodeBeingSource = flows[headerIndex].edges.filter(
          (edge) => edge.source === node.id
        );
        if (nodeBeingSource.length < 2) {
          nodesBeingTargetButNotSource.push(node);
        }
      } else if (node.type === "condition") {
        // check how many conditions are there
        const conditions = node.data.nodeInfo.conditions;
        // count the number of conditions inside the object conditions
        if (conditions) {
          const numberOfConditions = Object.keys(conditions).length;
          const nodeBeingSource = flows[headerIndex].edges.filter(
            (edge) => edge.source === node.id
          );

          if (nodeBeingSource.length < numberOfConditions + 1) {
            nodesBeingTargetButNotSource.push(node);
          }
        } else {
          nodesBeingTargetButNotSource.push(node);
        }
      } else {
        const nodeBeingSource = flows[headerIndex].edges.find(
          (edge) => edge.source === node.id
        );

        if (
          !nodeBeingSource &&
          node.type !== "end" &&
          node.type !== "queue" &&
          node.type !== "change"
        ) {
          nodesBeingTargetButNotSource.push(node);
        }
      }
    });
    return nodesBeingTargetButNotSource;
  };

  const blinkNodes = (nodesToBlink) => {
    let elementos = document.querySelectorAll("[data-id]");
    nodesToBlink.forEach((node) => {
      let elemento = document.querySelector(`[data-id="${node.id}"]`);
      elemento.style.animation = "blinker 1s linear infinite";

      setTimeout(() => {
        elemento.style.animation = "none";
      }, 5000);
    });
  };

  const saveFlows = async () => {
    const nodesBeingTarget = findNodesBeingTarget();

    const nodesBeingTargetButNotSource =
      findNodesBeingTargetButNotSource(nodesBeingTarget);

    if (nodesBeingTargetButNotSource.length > 0) {
      blinkNodes(nodesBeingTargetButNotSource);

      // alert(
      //   "Existem nós que são alvos de conexões, mas não possuem nenhuma conexão de saída ou nós de condição sem nenhuma condição."
      // );
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Existem nós que são alvos de conexões, mas não possuem nenhuma conexão de saída ou nós de condição sem nenhuma condição.",
      });
      return;
    }

    const response = await api.post("/setValue", {
      key: `${botId}`,
      value: JSON.stringify(dataToSave),
      expirationTime: true,
    });
    if (response.status === 200) {
      // alert("Flows salvos com sucesso!");
      Swal.fire({
        icon: "success",
        title: "Flows salvos com sucesso!",
      });
    } else {
      // alert("Erro ao salvar os flows");
      Swal.fire({
        icon: "error",
        title: "Erro ao salvar os flows",
      });
    }
  };

  return (
    <div>
      {!decryptReady ? (
        <div>Loading...</div>
      ) : loadedFlowFlag && decryptedData ? (
        <Box>
          <HeaderAppBar
            addNewFlow={addNewFlow}
            flows={flows}
            setIndex={setHeaderIndex}
            index={headerIndex}
            botId={botId}
            userId={decryptedData.userId}
            setFlows={setFlows}
          />
          {/* Main container for displaying the flow chart */}
          <div
            style={{
              background: "#1f1f23",
              height: `${containerHeight}px`,
              width: "100vw",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            {/* FlowTest component for rendering the flow chart */}
            <FlowTest
              key={headerIndex}
              flow={flows[headerIndex]}
              setFlows={setFlows}
              saveFlows={saveFlows}
              flows={flows}
              setIndex={setHeaderIndex}
              botId={botId}
            />
          </div>
        </Box>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default LandingPage;
